<div *ngIf="shouldShowFacilitySelect" class="d-flex align-items-center flex-grow-1">
    <fal *ngIf="showIcon" i="building" class="text-primary mr-1"></fal>
    <ng-container *ngIf="multi">
        <app-advanced-input type="select"
                            [(ngModel)]="orgFac"
                            (ngModelChange)="onFacilityChange($event)"
                            [searchFn]="facilityOptionSearchFn"
                            [selectItems]="facilityOptions"
                            [multi]="true"
                            [placeholder]="placeholder"
                            [clearable]="clearable"
                            groupBy="organizationName"
                            [class]="classes + ' flex-grow-1'"
                            [compareWith]="compareOnlyByFacilityId">
            <ng-template ng-option-tmp let-item=item>
                <ng-container *ngTemplateOutlet="optionTmp; context: {item: item}"></ng-container>
            </ng-template>
        </app-advanced-input>
    </ng-container>
    <ng-container *ngIf="!multi">
        <app-advanced-input type="select"
                            style="min-width: 200px !important;"
                            [ngModel]="orgFac"
                            (ngModelChange)="onFacilityChange($event)"
                            [searchFn]="facilityOptionSearchFn"
                            [selectItems]="facilityOptions"
                            [placeholder]="placeholder"
                            [clearable]="clearable"
                            groupBy="organizationName"
                            [class]="classes + ' flex-grow-1'"
                            [compareWith]="compareOption">
            <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center mr-1">
                    <span class="mr-auto">{{ item.name }}</span>
                    <span *ngIf="item.facility?.state" class="ml-2 small text-muted">{{ item.facility.state }}</span>
                </div>
            </ng-template>
            <ng-template ng-option-tmp let-item=item>
                <ng-container *ngTemplateOutlet="optionTmp; context: {item: item}"></ng-container>
            </ng-template>
        </app-advanced-input>
    </ng-container>
</div>

<ng-template #optionTmp let-item="item">
    <div class="d-flex align-items-center" [style.opacity]="item.facility?.is_inactive || adminView && item.facility?.is_suspended ? '.5' : null">
        <span class="mr-auto">
            {{ item.name }}
        </span>
        <div class="d-flex align-items-center">
            <span class="ml-2 small" *ngFor="let info of getAdditionalInfo(item.facility)">
                <fas *ngIf="info.icon; else infoText"
                     [i]="info.icon"
                     [ngbTooltip]="info.label"
                     class="text-{{info.colorClass}}">
                </fas>
                <ng-template #infoText>
                    <span class="text-muted">{{info}}</span>
                </ng-template>
            </span>
        </div>
    </div>
</ng-template>
